import { render, staticRenderFns } from "./InterestFollowUpForm.vue?vue&type=template&id=7b88ed2a&"
import script from "./InterestFollowUpForm.vue?vue&type=script&lang=js&"
export * from "./InterestFollowUpForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports